module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-33-min.0e42c319.jpg";